import UCSFEmbed from "../../../../content/issues/ucsf-parnassus/UCSFEmbed";
import * as React from 'react';
export default {
  UCSFEmbed,
  React
};